type ScreenHandler = (name: string, data?: Record<string, any>) => void

export const screenHandlers: ScreenHandler[] = []

export const addOnScreenHandler = (handler: ScreenHandler) => {
  screenHandlers.push(handler)
}
